import type { EventRecordingStatus } from 'models';
import { Card, Icon } from 'ui';
import { VideoRecording } from './video-recording';

type P = {
  src?: string;
  status?: EventRecordingStatus;
};

const EventDetailVideoRecording = ({ src, status }: P) => {
  if (!status || status === 'not_available') {
    return null;
  }

  return (
    <Card title={<Card.Title icon={<Icon icon="video-line" />}>Video recording</Card.Title>}>
      <VideoRecording src={src} status={status} />
    </Card>
  );
};

export default EventDetailVideoRecording;
